import React from "react";

import ChevronLeft from "@material-ui/icons/ChevronLeft";

import {
  Show,
  TextField,
  TopToolbar,
  ListButton,
  SimpleShowLayout,
  EditButton,
  useNotify,
  useRefresh,
  useRedirect,
  BooleanField,
  DateField,
  NumberField,
} from "react-admin";

const AntibioticsTitle = ({ record }) => {
  return <span>Provider {record ? `"${record.code}"` : ""}</span>;
};

const AntibioticsActions = ({ basePath, data }) => (
  <TopToolbar>
    <ListButton basePath={basePath} label="Back" icon={<ChevronLeft />} />
    <EditButton basePath={basePath} record={data} />
  </TopToolbar>
);

export const AntibioticsShow = (props) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  const onFailure = (error) => {
    notify(`Antibiotics ${error.message}`, "error");
    sleep(2500).then(() => {
      redirect("/antibiotics");
      refresh();
    });
  };

  return (
    <Show
      title={<AntibioticsTitle />}
      onFailure={onFailure}
      actions={<AntibioticsActions />}
      {...props}
    >
      <SimpleShowLayout>
        <TextField source="name" />
        <BooleanField source="is_discrete" />
        <DateField locales="es-UY" source="start_date" />
        <DateField locales="es-UY" source="end_date" />
        <TextField source="mic_susceptible_op" />
        <NumberField source="mic_susceptible" />
        <TextField source="mic_intermediate_op" />
        <NumberField source="mic_intermediate" />
        <TextField source="mic_resistant_breakpoint_op" />
        <NumberField source="mic_resistant_breakpoint" />
        <TextField source="notes" />

        <DateField
          source="createdAt"
          locales="es-UY"
          options={{ timeZone: "UTC" }}
          showTime
        />
        <DateField
          source="updatedAt"
          locales="es-UY"
          options={{ timeZone: "UTC" }}
          showTime
        />
      </SimpleShowLayout>
    </Show>
  );
};
